<template>
  <div class='UserPermission'>
    <div class="cont-label">Permissões do usuário:</div>
    <div class="cont">
      <user-permission-list
      v-for="(data, key) in Permission.filter((p, i) => i >= 0 && i <= 4)"
      :key="key"
      :data="data"
      />
    </div>
    <div class="cont cont-margin-top">
      <user-permission-list
      v-for="(data, key) in Permission.filter((p, i) => i >= 5 && i <= 9)"
      :key="key"
      :data="data"
      />
    </div>
    <div class="cont cont-margin-top">
      <user-permission-list
      v-for="(data, key) in Permission.filter((p, i) => i >= 10 && i <= 14)"
      :key="key"
      :data="data"
      />
    </div>
    <div class="cont cont-margin-top">
      <user-permission-list
      v-for="(data, key) in Permission.filter((p, i) => i >= 15 && i <= 19)"
      :key="key"
      :data="data"
      />
    </div>
    <div class="cont cont-margin-top">
      <user-permission-list
      v-for="(data, key) in Permission.filter((p, i) => i >= 20 && i <= 24)"
      :key="key"
      :data="data"
      />
    </div>
    <div class="cont cont-margin-top">
      <user-permission-list
      v-for="(data, key) in Permission.filter((p, i) => i >= 26 && i <= 30)"
      :key="key"
      :data="data"
      />
    </div>
    <div class="cont cont-margin-top">
      <user-permission-list
      v-for="(data, key) in Permission.filter((p, i) => i >= 25 && i <= 25)"
      :key="key"
      :data="data"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserPermissionList from './UserPermissionList'
export default {
  name: 'UserPermission',
  components: { UserPermissionList },
  computed: {
    ...mapGetters(['Permission'])
  }
}
</script>

<style scoped>
.cont-label {
  text-align: left;
  padding: 1%;
  font-size: 12px
}

.cont {
  border: thin solid #CCCCCC;
  border-radius: 7px;
}

.cont-margin-top {
  margin-top: 3%;
}
</style>
